import React, { useEffect, useState } from "react"
import PageMetaTags from "components/PageMetaTags"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import {
  getDomain,
  getMetaTags,
  resetMetaTags,
  createDomain,
  updateDomain,
  createMetaTag,
} from "store/actions"
import { connect } from "react-redux"
import { Col, Container, Row } from "reactstrap"
import { useParams } from "react-router-dom"
import DomainForm from "containers/Domains/domainForm"

const Domain = props => {
  const params = useParams()

  useEffect(async () => {
    props.getMetaTags({ hide_for_business_unit: true })
    if (params.id) {
      props.getDomain({ id: params.id })
    }
    return () => {
      props.resetMetaTags()
    }
  }, [])

  const mapTags = (tags = []) => {
    return tags
      .map(tag => {
        if (tag.value || tag.value === 0) {
          return tag.value
        } else {
          const matchingTag = props.metaTags.find(
            metaTag => metaTag.tag === tag.label
          )
          return matchingTag ? matchingTag.id : null
        }
      })
      .filter(tag => !!tag)
  }

  const handleSubmit = values => {
    let data = {
      vendor_id: props.vendorId,
      name: values.name,
      tags: values.tags,
      tag_ids: mapTags(values.tags),
    }
    if (values.id) {
      data.id = values.id
      props.updateDomain(data)
    } else {
      props.createDomain(data)
    }
  }

  const handleCreateTag = tagLabel => {
    props.createMetaTag({
      values: {
        vendor_id: props.vendorId,
        tag: tagLabel,
        invisible: false,
        business_unit_id: null,
      },
    })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title={"Domains list"} />
        <Container fluid>
          <BreadcrumbTitle
            title={"Domain"}
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Domains",
                link: "/domains",
              },
              { title: props?.domain ? "Edit Domain" : "Create Domain" },
            ]}
          />
          <Row>
            <DomainForm
              onSubmit={handleSubmit}
              metaTags={props.metaTags}
              initialValues={
                props.domain && {
                  ...props.domain,
                  vendor_id: props.domain.vendor_id || props.vendorId,
                }
              }
              onTagCreate={handleCreateTag}
              loading={props.loading}
            />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
const mapStateToProps = state => ({
  domain: state.domains.domain,
  metaTags: state.Tags.metaTags,
  loading: state.domains.loading,
  vendorId: state.Login.vendorId,
})

const mapDispatchToProps = dispatch => ({
  getDomain: values => dispatch(getDomain(values)),
  getMetaTags: values => dispatch(getMetaTags(values)),
  resetMetaTags: () => dispatch(resetMetaTags()),
  createDomain: domain => dispatch(createDomain(domain)),
  updateDomain: domain => dispatch(updateDomain(domain)),
  createMetaTag: values => dispatch(createMetaTag(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Domain)
